import { render, staticRenderFns } from "./TendersHeader.vue?vue&type=template&id=09c84f86"
import script from "./TendersHeader.vue?vue&type=script&lang=js"
export * from "./TendersHeader.vue?vue&type=script&lang=js"
import style0 from "./TendersHeader.vue?vue&type=style&index=0&id=09c84f86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports